import { CorrespondentContact as ICorrespondentContact } from '../../../models/pro.model';
import {
  cellBaseStyle,
  fullWidthCellStyle,
  linkColour,
  tableSubHeaderColour,
  tableWidth,
} from '../pro-report-email-styles';
import {
  ProReportEmailFullWidthInfoRow,
  ProReportEmailFullWidthTableHeader,
} from './pro-report-email-common-components';

interface ProReportEmailCorrespondentContactProps {
  correspondentContact?: ICorrespondentContact | null;
}

function ProReportEmailCorrespondentContact({
  correspondentContact,
}: ProReportEmailCorrespondentContactProps) {
  const headerText = 'Correspondent contact';
  return (
    <table
      width={tableWidth}
      cellPadding={0}
      cellSpacing={0}
      style={{ borderCollapse: 'collapse', margin: 0, padding: 0 }}
      role="presentation"
    >
      <ProReportEmailFullWidthTableHeader headerText={headerText} />
      {correspondentContact && (
        <>
          <ProReportEmailFullWidthInfoRow
            heading="Company:"
            content={correspondentContact.company ?? 'N/A'}
            backgroundColor={tableSubHeaderColour}
          />
          <tr>
            <td
              colSpan={1}
              style={{
                ...cellBaseStyle,
              }}
            >
              <strong>Name: </strong>
              {correspondentContact.name ?? 'N/A'}
            </td>
            <td
              colSpan={1}
              style={{
                ...cellBaseStyle,
              }}
            >
              <strong>Email: </strong>
              {correspondentContact.email ? (
                <a
                  href={`mailto:${correspondentContact.email}`}
                  style={{
                    color: linkColour,
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                  }}
                >
                  {correspondentContact.email}
                </a>
              ) : (
                'N/A'
              )}
            </td>
          </tr>
          <tr>
            <td
              colSpan={2}
              style={{
                ...fullWidthCellStyle,
              }}
            >
              <strong>Telephone: </strong>
              {correspondentContact.telephone ?? 'N/A'}
            </td>
          </tr>
        </>
      )}
      <tr>
        <td
          colSpan={2}
          style={{
            ...fullWidthCellStyle,
          }}
        >
          Visit our{' '}
          <a
            href="https://north-standard.com/correspondents-search"
            target="_blank"
            rel="noreferrer"
            style={{
              color: linkColour,
              textDecoration: 'none',
              fontWeight: 'bold',
            }}
          >
            Correspondents Search
          </a>{' '}
          for our global network of correspondents.
        </td>
      </tr>
    </table>
  );
}

ProReportEmailCorrespondentContact.defaultProps = {
  correspondentContact: null,
};

export default ProReportEmailCorrespondentContact;
